import React, { useEffect, useState } from 'react'
import { v2_categories, v2_channels } from '../../../actions/v2/masterData';

const Filter = ({ onChangeFilter, statusCount, initialFilter = {} }) => {

    const [state, setState] = useState({
        channel: { name: 'channel', value: initialFilter.channelId || '', options: [] },
        status: { name: 'status', value: initialFilter.status || '', options: ['Draft', 'Open', 'Close'] },
        category: { name: 'category', value: initialFilter.categoryId || '', options: [] },
        keyword: { name: 'keyword', value: initialFilter.keyword || '' },
        fromDate: { name: 'fromDate', value: initialFilter.fromDate || '' },
        toDate: { name: 'toDate', value: initialFilter.toDate || '' },
        favourite: { name: 'favourite', value: Boolean(initialFilter.favourite) },
        hasMyComment: { name: 'hasMyComment', value: Boolean(initialFilter.hasMyComment) },
        hasDraftReply: { name: 'hasDraftReply', value: Boolean(initialFilter.hasDraftReply) },

    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: value
            }
        }));
    };

    useEffect(() => {
        const model = {
            channelId: state.channel.value,
            categoryId: state.category.value,
            favourite: state.favourite.value,
            hasMyComment: state.hasMyComment.value,
            keyword: state.keyword.value,
            hasDraftReply: state.hasDraftReply.value,
            status: state.status.value,
            fromDate: state.fromDate.value,
            toDate: state.toDate.value
        }
        onChangeFilter(model)
    }, [state])
    useEffect(() => {
        v2_channels().then((res) => {
            if (res.status && res.result) {
                setState((prev) => ({
                    ...prev,
                    channel: {
                        ...prev.channel,
                        options: res.result.map((item) => ({
                            label: item.CHANNEL_NAME,
                            value: item.ID,
                        }))
                    }
                }));
            }
        });

        v2_categories().then((res) => {
            if (res.status && res.result) {
                setState((prev) => ({
                    ...prev,
                    category: {
                        ...prev.category,
                        options: res.result.map((item) => ({
                            label: item.CATEGORY_NAME,
                            value: item.ID,
                        }))
                    }
                }));
            }
        })


    }, []);
    return (
        <div className="col-md-12 ">
            <div className="plan-approval-index-top">
                <div className="filter-channels-box">
                    <div className="stats-channels-type">

                        <div className="counter-box">
                            <div className="name">Draft</div>
                            <div className="value">{statusCount?.Draft}</div>
                        </div>
                        <div className="counter-box">
                            <div className="name">Open</div>
                            <div className="value">{statusCount?.Open}</div>
                        </div>
                        <div className="counter-box">
                            <div className="name">Close</div>
                            <div className="value">{statusCount?.Close}</div>
                        </div>

                    </div>
                </div>
                <div className="filter-tab-channels-box">
                    <div className="input-box">
                        <select className="form-select w200"
                            name={state.channel.name}
                            value={state.channel.value}
                            onChange={handleChange}

                        >
                            <option value="">Channels </option>
                            {state.channel.options.map((option) => {
                                return (
                                    <option value={option.value}>{option.label}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className="input-box">
                        <select className="form-select" style={{ width: 180 }}
                            name={state.category.name}
                            value={state.category.value}
                            onChange={handleChange}
                        >
                            <option value="">Categories</option>
                            {state.category.options.map((option) => {
                                return (
                                    <option value={option.value}>{option.label}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className={state.hasMyComment.value ? 'input-box active' : 'input-box'}>
                        <button type="button"
                            onClick={() =>
                                handleChange({
                                    target: {
                                        name: 'hasMyComment',
                                        value: !state.hasMyComment.value,
                                    },
                                })
                            }
                        >
                            <i className="fa fa-edit" /> Has My Comments
                        </button>
                    </div>
                    {/* <div className={state.favourite.value ? 'input-box active' : 'input-box'}>
                        <button type="button"
                            onClick={() =>
                                handleChange({
                                    target: {
                                        name: 'favourite',
                                        value: !state.favourite.value,
                                    },
                                })
                            }
                        >
                            <i className="bx bx-star" /> My Favourites
                        </button>
                    </div> */}

                    <div className={state.hasDraftReply.value ? 'input-box active' : 'input-box'}>
                        <button type="button"
                            onClick={() =>
                                handleChange({
                                    target: {
                                        name: 'hasDraftReply',
                                        value: !state.hasDraftReply.value,
                                    },
                                })
                            }
                        >
                            <i className="fa fa-edit" /> Has Draft Reply
                        </button>
                    </div>
                    <div className="input-box">
                        <select className="form-select" style={{ width: 180 }}
                            name={state.status.name}
                            value={state.status.value}
                            onChange={handleChange}
                        >
                            <option value={''}>Status</option>
                            {state.status.options.map((option) => {
                                return (
                                    <option value={option}>{option}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className="input-box">
                        <input
                            className="form-control"
                            type="text"
                            onFocus={(e) => (e.target.type = "date")}
                            onBlur={(e) => !e.target.value && (e.target.type = "text")}
                            placeholder="From Date"
                            onChange={handleChange}
                            value={state.fromDate.value}
                            name={state.fromDate.name}
                        />
                    </div>
                    <div className="input-box">
                        <input
                            className="form-control"
                            type="text"
                            onFocus={(e) => (e.target.type = "date")}
                            onBlur={(e) => !e.target.value && (e.target.type = "text")}
                            placeholder="To Date"
                            onChange={handleChange}
                            value={state.toDate.value}
                            name={state.toDate.name}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Filter
